// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : LAST EMI DETAILS ACTION CREATED
// MODIFIED DATE: 08-10-2025

import LastEMIDetailsActionTypes from './last-emi-details.types';

/** ***************** GET LAST EMI DETAILS START *********************** */
export const getLastEMIDetailsStart = (getData: any) => ({
	type: LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_START,
	payload: getData,
});

export const getLastEMIDetailsSuccess = (successData: any) => ({
	type: LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_SUCCESS,
	payload: successData,
});

export const getLastEMIDetailsFailure = (failureData: any) => ({
	type: LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_FAILURE,
	payload: failureData,
});

export const getLastEMIDetailsResponseResetStart = () => ({
	type: LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_RESPONSE_RESET,
});

export const getLastEMIDetailsResponseChanged = () => ({
	type: LastEMIDetailsActionTypes.GET_LAST_EMI_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET LAST EMI DETAILS DETAILS END *********************** */
